import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import type { StaffUser } from '../../data/types';
import { useRegistry } from '../../store/RegistryStore';
import { useToast } from '../../ui/feedback';
import { statusLabel } from '../../ui/statusTones';
import StaffProfileDialog from './StaffProfileDialog';

export default function UsersTab() {
  const { state, dispatch } = useRegistry();
  const toast = useToast();
  const [editing, setEditing] = useState<StaffUser | null>(null);
  const users = state.users.filter((user) => user.tenantId === state.currentTenantId);
  return (
    <Paper variant="outlined">
      <Typography variant="body2" color="text.secondary" sx={{ px: 2.5, pt: 2 }}>
        Each person&apos;s profile fills in the account contact when they set up a deal, or when
        someone chooses them as the contact.
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Job title</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Work address</TableCell>
              <TableCell>Registry role</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell sx={{ fontWeight: 600 }}>{user.name}</TableCell>
                <TableCell>{user.title || '—'}</TableCell>
                <TableCell>{user.email || '—'}</TableCell>
                <TableCell>{user.phone || '—'}</TableCell>
                <TableCell>{user.address || '—'}</TableCell>
                <TableCell>{statusLabel(user.role)}</TableCell>
                <TableCell align="right">
                  <Button size="small" onClick={() => setEditing(user)}>
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {editing && (
        <StaffProfileDialog
          user={editing}
          onClose={() => setEditing(null)}
          onSave={(patch) => {
            dispatch({ type: 'STAFF_PROFILE_UPDATE', userId: editing.id, patch });
            toast('Profile saved');
            setEditing(null);
          }}
        />
      )}
    </Paper>
  );
}
